import { render, staticRenderFns } from "./cms-block-image.vue?vue&type=template&id=2b896d80&scoped=true"
import script from "./cms-block-image.vue?vue&type=script&lang=js"
export * from "./cms-block-image.vue?vue&type=script&lang=js"
import style0 from "./cms-block-image.vue?vue&type=style&index=0&id=2b896d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b896d80",
  null
  
)

export default component.exports